<template>
  <el-dialog
    :visible.sync="addServiceDialog"
    width="50%"
    title="设备"
    :close-on-click-modal="false"
  >
    <el-form :inline="true">
    
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #name="{ row }">
        {{getName(row)}}
      </template>
      <template #handler="{ row }">
        <div>
        <el-popconfirm
            @confirm="delUser(row)"
            title="确认要删除用户吗"
          >
            <el-button slot="reference" type="danger" size="small">删除</el-button>
          </el-popconfirm>
        </div>
      </template>
    </auto-table>

    <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
         { name: "id", value: "user_id" },
        { name: "姓名", value: "name" },
        { name: "结束时间", value: "expired_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      role: "coach",
      addServiceDialog: false,
      device: {},
    };
  },
  methods: {
    open(row) {
      this.device = row;
      this.addServiceDialog = true;
      this.getList(1)
    },
     delUser(row){

        let param={
            deviceId:this.device.device_id,
            ids:[row.userId]
        }
        this.$post('device/deviceUser/removeUser',param).then(res=>{
          this.$message('删除成功')
           this.getList(1);
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      let url = "/device/deviceUser/queryManagerListPage";
      let params = {
        currentPage: page,
        pageSize: 10,
        device_id: this.device.device_id
      };
      
      this.$get(url, params).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>